import { EActionCode } from 'affiny-core/modules/api/repositories/payment/paymentActionCodes';
import { ActionsUnion, createAction } from 'affiny-core/modules/helpers';
import { getReturnRoute } from 'affiny-core/redux/actions/goToRatecardActions';

export enum ESpecialOffersActionType {
  GET_CURRENT_SPECIAL_OFFER = 'SPECIAL_OFFERS/GET_CURRENT',
  HIDE_CURRENT_SPECIAL_OFFER = 'SPECIAL_OFFERS/HIDE_CURRENT',
  GET_PAYMENT_URL_FOR_SO = 'GET_PAYMENT_URL_FOR_SO',
}

export interface IGetCurrentSpecialOfferActionParams {
  actionCode: EActionCode;
  returnRouteOk?: string;
  returnRouteKo?: string;
}

export const specialOffersActions = {
  getCurrentSpecialOffer: () =>
    createAction(ESpecialOffersActionType.GET_CURRENT_SPECIAL_OFFER),
  hideCurrentSpecialOffer: () =>
    createAction(ESpecialOffersActionType.HIDE_CURRENT_SPECIAL_OFFER),
  goToRateCardSO: ({
    actionCode,
    returnRouteOk,
    returnRouteKo,
  }: IGetCurrentSpecialOfferActionParams) =>
    createAction(ESpecialOffersActionType.GET_PAYMENT_URL_FOR_SO, {
      actionCode,
      returnRouteOk: returnRouteOk ? returnRouteOk : getReturnRoute(),
      returnRouteKo: returnRouteKo ? returnRouteKo : getReturnRoute(),
    }),
};

export type TSpecialOffersAction = ActionsUnion<typeof specialOffersActions>;
